import { useSyncExternalStore } from "react";

function subscribe(callback: () => void) {
  window.addEventListener("hashchange", callback);
  return () => window.removeEventListener("hashchange", callback);
}

export function useHashParams() {
  const hash = useSyncExternalStore(subscribe, () => location.hash);
  return new URLSearchParams(hash.split("?")[1] ?? "");
}

export function replaceHashParams(values: Record<string, string | null>) {
  const base = location.hash.split("?")[0] || "#/foerderungen";
  const params = new URLSearchParams(location.hash.split("?")[1] ?? "");
  for (const [key, value] of Object.entries(values)) {
    if (value === null) params.delete(key);
    else params.set(key, value);
  }
  const query = params.toString();
  history.replaceState(null, "", base + (query ? `?${query}` : ""));
  window.dispatchEvent(new HashChangeEvent("hashchange"));
}
